import type { PropsWithChildren } from 'react';

import { ConnectModalProvider } from './contexts/connect-modal';
import { WalletConnectStateProvider } from './contexts/wallet-connect-state';
import type { Chains, WalletAdapterData } from './types';

type Props = {
  chains: Readonly<Chains>;
  wallets: WalletAdapterData[];
  chainId: number;
};

export const Web3ModalProvider = ({ chains, children, wallets, chainId }: PropsWithChildren<Props>) => {
  return (
    <WalletConnectStateProvider chains={chains as Chains} chainId={chainId} wallets={wallets}>
      <ConnectModalProvider>{children}</ConnectModalProvider>
    </WalletConnectStateProvider>
  );
};
